import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';

const API_URL = '/api/comida';

function Comida() {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ buffet: '', valor_por_convidado: '', valor_total: '' });
  const [editId, setEditId] = useState(null);

  const fetchDados = async () => {
    const res = await axios.get(API_URL);
    setDados(res.data);
  };

  useEffect(() => {
    fetchDados();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`${API_URL}/${editId}`, form);
    } else {
      await axios.post(API_URL, form);
    }
    setForm({ buffet: '', valor_por_convidado: '', valor_total: '' });
    setEditId(null);
    fetchDados();
  };

  const handleEdit = (item) => {
    setForm({ buffet: item.buffet, valor_por_convidado: item.valor_por_convidado, valor_total: item.valor_total });
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    fetchDados();
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Comida / Buffet</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <TextField label="Buffet" name="buffet" value={form.buffet} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Valor por convidado" name="valor_por_convidado" value={form.valor_por_convidado} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <TextField label="Valor total" name="valor_total" value={form.valor_total} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <Button type="submit" variant="contained" color="primary">{editId ? 'Salvar' : 'Adicionar'}</Button>
          {editId && <Button onClick={() => { setEditId(null); setForm({ buffet: '', valor_por_convidado: '', valor_total: '' }); }} sx={{ ml: 2 }}>Cancelar</Button>}
        </form>
      </Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Buffet</TableCell>
            <TableCell>Valor por convidado</TableCell>
            <TableCell>Valor total</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dados.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.buffet}</TableCell>
              <TableCell>{item.valor_por_convidado}</TableCell>
              <TableCell>{item.valor_total}</TableCell>
              <TableCell>
                <Button size="small" onClick={() => handleEdit(item)}>Editar</Button>
                <Button size="small" color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default Comida;
